exports = module.exports = require("../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3EvOMW_HFSy3VYtO3iJITr{\n    text-align: right;\n    width: 100%;\n    display: inline-block;\n}\n._1wAPdHjMYI9g7_PSPVS1It{\n    color: inherit !important;\n    padding: 5px !important;\n    border-style: solid !important;\n    border-width: 1px !important;\n    border-color: #d9d9d9 !important;\n    width: 100% !important;\n    border-radius: 3px !important;\n    font-size: 14px !important;\n    margin-right: 5px !important;\n}", ""]);

// exports
exports.locals = {
	"label": "_3EvOMW_HFSy3VYtO3iJITr",
	"input": "_1wAPdHjMYI9g7_PSPVS1It"
};